import { Component, OnInit } from '@angular/core';
import { ImgUpload } from '../../../../models/ImgUpload.model';
import { UploadImageService } from '../../../../services/upload-img.service';
import { PropertiesService } from '../../../../services/properties.service';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.css'],
    standalone: false
})
export class UploadComponent  {
  imgs =new Array<any>();
  urls = new Array<string>();
  propiedad : any;
  imagenes : any;
  constructor(private uploadImageService:UploadImageService,private activateRoute: ActivatedRoute,
      private propertieService: PropertiesService, private router: Router) {

          // this.activateRoute.params.subscribe(params => {
          // this.propiedad = this.uploadImageService.getImagenes(params.id)
          //   .subscribe((data: any[]) => {
          //       console.log(data);
          //       this.propiedad = data;
          //       this.propiedad.id=params.id;
          //       this.loadFiles(this.propiedad);
          //     });
          //     this.propiedad = this.propiedad;
              
          //   });

                // Obtener datos y fotos de la propiedad
                this.activateRoute.params.subscribe(params => {
                  forkJoin({
                    data: this.propertieService.getpropiedad(params.id),
                    img: this.uploadImageService.getImagenes(params.id),
                  }).subscribe(({ data, img }) => {
                    this.propiedad = data;
                    this.imagenes = img;
                    this.loadFiles(this.imagenes);
                  });
                });
        
  }

  loadFiles(files) {

    if (files) {
      for (let i = 0; i < files.length; i++) {
        
        // let reader = new FileReader();
        // reader.onload = (e: any) => {
        //   this.urls.push(e.target.result);
        //  this.imgs[i].imagen=e.target.result;
           this.imgs.push({
            imageData: 'data:image/png;base64,'+ files[i].thumbnail,
            orden:files[i].orden,
            descripcion: "",
            banner: files[i].banner,
            principal: files[i].principal,
            imagenId: files[i].imagenId
           }
           )
        // }
        // reader.readAsDataURL(files[i]);
      }
    }
  }

  detectFiles(event) {
    this.urls = [];
    let files = event.target.files;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.urls.push(e.target.result);
        //  this.imgs[i].imagen=e.target.result;
           this.imgs.push({
            imageData: e.target.result,
            orden: this.imagenes[this.imagenes.length - 1] === undefined ?i+1:this.imagenes[this.imagenes.length - 1].orden+1,
            descripcion: "",
            banner: false,
            principal: false,
           }
           )
        }
        reader.readAsDataURL(files[i]);
      }
    }
  }

  uploadFiles(events){
    let imagenes =JSON.parse( JSON.stringify( events ) );
    for (let i = 0; i < imagenes.length; i++) {
      imagenes[i].imageData= imagenes[i].imageData.substr(imagenes[i].imageData.indexOf(',') + 1);
      imagenes[i].tipoImagenId=4;
    };
   
      this.uploadImageService.postImages(this.propiedad.id,imagenes).subscribe(
        data=>( this.router.navigate(['/admin/principal'])));
    
   console.log(imagenes);
  }

  // _handleReaderLoaded(e) {
  //   let reader = e.target;
  //   var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
  // console.log(base64result);
  // }
  cancelar(){
    this.router.navigate(['../admin/principal']);
  }
onDragOver(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  (event.currentTarget as HTMLElement).classList.add('dragover');
}

onDragLeave(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  (event.currentTarget as HTMLElement).classList.remove('dragover');
}

onDrop(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  (event.currentTarget as HTMLElement).classList.remove('dragover');

  if (event.dataTransfer?.files?.length) {
    this.detectFiles({ target: { files: event.dataTransfer.files } });
  }
}

}